// Lazy-load <video[data-mg-video]> and skip entirely on mobile / data-saver.
// Background videos hosted by Shopify land at HD-1080p ~5–10 MiB; loading
// that on cellular for a decorative loop tanks LCP and total page weight.
// Mobile / reduced-motion / save-data: leave the poster showing, never load.
// Desktop: load via IntersectionObserver with 200px rootMargin.
(function () {
  'use strict';

  function shouldSkipVideo() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;
    if (window.matchMedia('(max-width: 767px)').matches) return true;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && conn.saveData) return true;
    if (conn && (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g' || conn.effectiveType === '3g')) return true;
    return false;
  }

  function loadVideo(video) {
    if (video.dataset.mgVideoLoaded === '1') return;
    video.dataset.mgVideoLoaded = '1';
    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (s) {
      if (s.dataset.src && !s.src) s.src = s.dataset.src;
    });
    video.load();
    var play = video.play();
    if (play && typeof play.then === 'function') {
      play.catch(function () { /* autoplay-blocked is fine; poster stays. */ });
    }
  }

  function init() {
    var videos = document.querySelectorAll('video[data-mg-video]');
    if (videos.length === 0) return;

    if (shouldSkipVideo()) {
      // Stay with the poster image, never download the video.
      return;
    }

    if (typeof IntersectionObserver !== 'function') {
      // Old browser: just load eagerly.
      videos.forEach(loadVideo);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px 200px 0px', threshold: 0 });

    videos.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
